<template>
  <div>
    <!-- 버튼 리스트 -->
    <vs-row v-if="isSuperUser" >
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <div class="mb-4 ml-auto">
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickMoveList">목록</vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="onClickReturn">기본값으로</vs-button>
          <vs-button class="ml-4" color="secondary" @click="onClickSave">저장</vs-button>
        </div>
      </vs-col>
    </vs-row>


    <!-- 첫번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 산업안전보건법 상 산업재해
        </h5>
        <div v-if="isSuperUser" class="ml-auto">
          <vs-button color="secondary" @click="addRow('산업안전보건법_산업재해')"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow('산업안전보건법_산업재해')"> 마지막 항목삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">정의 및 상황</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr v-for="(data, i) in form.산업안전보건법_산업재해">
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.no"/>
            <span v-else>{{ data.no }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input1"/>
            <span v-else>{{ data.input1 }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input2"/>
            <span v-else>{{ data.input2 }}</span>
          </td>
        </tr>
      </table>
    </vs-row>

    <!-- 두번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 중대재해처벌법 상 중대산업재해
        </h5>
        <div v-if="isSuperUser" class="ml-auto">
          <vs-button color="secondary" @click="addRow('중대재해처벌법_중대산업재해')"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow('중대재해처벌법_중대산업재해')"> 마지막 항목삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">정의 및 상황</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr v-for="(data, i) in form.중대재해처벌법_중대산업재해">
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.no"/>
            <span v-else>{{ data.no }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input1"/>
            <span v-else>{{ data.input1 }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input2"/>
            <span v-else>{{ data.input2 }}</span>
          </td>
        </tr>
      </table>
    </vs-row>

    <!-- 세번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 중대재해처벌법 상 중대시민재해
        </h5>
        <div v-if="isSuperUser" class="ml-auto">
          <vs-button color="secondary" @click="addRow('중대재해처벌법_중대시민재해')"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow('중대재해처벌법_중대시민재해')"> 마지막 항목삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">정의 및 상황</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr v-for="(data, i) in form.중대재해처벌법_중대시민재해">
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.no"/>
            <span v-else>{{ data.no }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input1"/>
            <span v-else>{{ data.input1 }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input2"/>
            <span v-else>{{ data.input2 }}</span>
          </td>
        </tr>
      </table>
    </vs-row>

    <!-- 네번째 색션 -->
    <vs-row>
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5>
          <i class="dot"></i> 산업안전보건법 상 중대재해
        </h5>
        <div v-if="isSuperUser" class="ml-auto">
          <vs-button color="secondary" @click="addRow('산업안전보건법_중대재해')"> 항목추가 </vs-button>
          <vs-button color="secondary" type="border" class="ml-2" @click="deleteRow('산업안전보건법_중대재해')"> 마지막 항목삭제 </vs-button>
        </div>
      </vs-col>
    </vs-row>
    <vs-row class="my-4">
      <table class="mb-4 table-wrap">
        <tr>
          <th class="p-4 th-cell">번호</th>
          <th class="p-4 th-cell">정의 및 상황</th>
          <th class="p-4 th-cell">내용</th>
        </tr>
        <tr v-for="(data, i) in form.산업안전보건법_중대재해">
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.no"/>
            <span v-else>{{ data.no }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input1"/>
            <span v-else>{{ data.input1 }}</span>
          </td>
          <td class="p-4 td-cell" >
            <ml-input v-if="isSuperUser" class="w-full" v-model="data.input2"/>
            <span v-else>{{ data.input2 }}</span>
          </td>
        </tr>
      </table>
    </vs-row>
  </div>
</template>

<script>
import PopupPlanProject from '@/views/project/popup/PopupPlanProject'
import DateSelector from '@/components/selector/DateSelector'
import PopupProjectSetting from '@/views/project/PopupProjectSetting'
import MemberSelector from '@/components/selector/MemberSelector'
import CompanySelector from '@/components/selector/CompanySelector'
import FileUploader from '@/components/FileUploader'

export default {
  components: {
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object
  },
  computed: {
    isSuperUser() {
      return !!this.myInfo.is_superuser
    },
    myInfo () {
      return this.$store.state.auth.userInfo
    },
    projectId() {
      return parseInt(this.$route.params.proj_id);
    },
    boardId() {
      return parseInt(this.$route.params.boardId);
    },
    list () {
      return this.$store.state.board.postListInfo.data
    },
    default_산업안전보건법_산업재해() {
      return [
        { no: '1', input1: '정의', input2: '업무로 인한 3일 이상 휴업 재해' },
        { no: '2', input1: '응급조치', input2: '사고유발 행위 또는 기계 정지, 구호조치/ 119 호출 및 병원진료·이송' },
        { no: '3', input1: '유선보고', input2: '중대산업재해 전담조직, 사업장별 주관부서' },
        { no: '4', input1: '산업재해조사표 작성 및 제출', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청(산업재해 : 1개월 이내)' },
        { no: '5', input1: '사고원인조사 및 대책수립', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청(산업재해 : 1개월 이내)' },
      ]
    },
    default_중대재해처벌법_중대산업재해() {
      return [
        { no: '1', input1: '정의', input2: '(1) 사망자 1명 이상\n' +
            '(2) 3개월 이상 부상자\n' +
            '(3) 부상자 또는 직업성 질병 동시 10명 이상' },
        { no: '2', input1: '응급조치', input2: '필요시 119 호출 및 병원진료·이송' },
        { no: '3', input1: '작업중지 조치', input2: '' },
        { no: '4', input1: '(필요시) 초기대응 및 대피', input2: '' },
        { no: '5', input1: '유선보고', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청' },
        { no: '6', input1: '현장보존', input2: '' },
        { no: '7', input1: '산업재해조사표 작성 및 제출', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청(중대재해 : 즉시)' },
        { no: '8', input1: '사고원인조사 및 대책수립', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청(중대재해 : 즉시)' },
      ]
    },
    default_중대재해처벌법_중대시민재해() {
      return [
        { no: '1', input1: '정의', input2: '(1) 사망자 1명 이상\n' +
            '(2) 3개월 이상 부상자\n' +
            '(3) 부상자 또는 직업성 질병 동시 10명 이상' },
        { no: '2', input1: '응급조치', input2: '필요시 119 호출 및 병원진료·이송' },
        { no: '3', input1: '작업중지 조치', input2: '' },
        { no: '4', input1: '(필요시) 초기대응 및 대피', input2: '' },
        { no: '5', input1: '유선보고', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청' },
        { no: '6', input1: '현장보존', input2: '' },
        { no: '7', input1: '산업재해조사표 작성 및 제출', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청(중대재해 : 즉시)' },
        { no: '8', input1: '사고원인조사 및 대책수립', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청(중대재해 : 즉시)' },
      ]
    },
    default_산업안전보건법_중대재해() {
      return [
        { no: '1', input1: '정의', input2: '(1) 사망자 1명 이상\n' +
            '(2) 3개월 이상 부상자\n' +
            '(3) 부상자 또는 직업성 질병 동시 10명 이상' },
        { no: '2', input1: '응급조치', input2: '필요시 119 호출 및 병원진료·이송' },
        { no: '3', input1: '작업중지 조치', input2: '' },
        { no: '4', input1: '(필요시) 초기대응 및 대피', input2: '' },
        { no: '5', input1: '유선보고', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청' },
        { no: '6', input1: '현장보존', input2: '' },
        { no: '7', input1: '산업재해조사표 작성 및 제출', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청(중대재해 : 즉시)' },
        { no: '8', input1: '사고원인조사 및 대책수립', input2: '중대산업재해 전담조직, 사업장별 주관부서, 고용노동지청(중대재해 : 즉시)' },
      ]
    }
  },
  watch: {
    board: {
      immediate: true,
      deep: true,
      handler (/*value*/) {
      }
    },
    value: {
      important: true,
      deep: true,
      handler (value) {
        const keys = Object.keys(this.form)
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key]
          }
        }
      }
    },
    form: {
      immediate: true,
      deep: true,
      handler (value) {
        this.$emit('input', value)
      }
    },
    list(list) {
      if (list.length > 0) {
        const data = JSON.parse(list[0].post_content)
        this.form = data.body
      }
    }
  },
  async mounted () {
    this.initForm()
    await this.loadListBoard()

    console.log("this.form", this.myInfo)
  },
  data () {
    return {
      form: {
        산업안전보건법_산업재해: [],
        중대재해처벌법_중대산업재해: [],
        중대재해처벌법_중대시민재해: [],
        산업안전보건법_중대재해: [],
      },
    }
  },
  methods: {
    initForm () {
      this.form.산업안전보건법_산업재해 = JSON.parse(JSON.stringify(this.default_산업안전보건법_산업재해))
      this.form.중대재해처벌법_중대산업재해 = JSON.parse(JSON.stringify(this.default_중대재해처벌법_중대산업재해))
      this.form.중대재해처벌법_중대시민재해 = JSON.parse(JSON.stringify(this.default_중대재해처벌법_중대시민재해))
      this.form.산업안전보건법_중대재해 = JSON.parse(JSON.stringify(this.default_산업안전보건법_중대재해))
    },
    onClickReturn () {
      this.initForm();
    },
    onClickMoveList () {
      this.$router.back()
    },
    onClickSave () {
      if (this.list && this.list.length > 0) {
        this.saveBoardPost("update");
      } else {
        this.saveBoardPost("create");
      }
    },
    addRow (form_key) {
      this.form[form_key].push({ no: '', input1: '', input2: '' })
    },
    deleteRow (form_key) {
      this.form[form_key].pop()
    },
    async loadListBoard () {
      const boardId = this.boardId
      const page = 1
      const perPage = 5
      await this.$store.dispatch('board/LOAD_POST_LIST', {
        projectId: this.projectId,
        boardId,
        page,
        perPage,
      })
    },
    async saveBoardPost(type) {
      const form = {
        header: {
          full: new Date().format('yyyy-MM-dd'),
          month: new Date().getMonth()+1,
          year: new Date().getFullYear(),
        },
        body: this.form,
        summary: {}
      };

      const projectId = this.projectId;
      const boardId = this.boardId;
      const title = '산업재해 발생 시 보고 절차 안내';
      const content = JSON.stringify(form);

      if (type === "create") {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
        });
      } else if (type === "update") {
        const postId = this.list[0].id;
        await this.$store.dispatch("board/UPDATE_POST", {
          projectId,
          boardId,
          postId,
          title,
          content,
        });
      }
      this.oldForm = JSON.parse(JSON.stringify(this.form));
    },
  }
}
</script>

<style scoped>
.table-wrap {
  width: 100%;
  border-spacing: 0;
  border-top: 1px solid #cdcdcd;
  border-left: 1px solid #cdcdcd;
}

.th-cell {
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd;
  background-color: #f9f9f9;
  text-align: center;
  font-weight: 500;
  font-size: 14px;
}

.th-cell:nth-child(1) {
  max-width: 130px;
  width: 130px;
}

.th-cell:nth-child(2) {
  max-width: 390px;
  width: 390px;
}

.td-cell {
  font-weight: 500;
  white-space: nowrap;
  border-right: 1px solid #cdcdcd;
  border-bottom: 1px solid #cdcdcd
}
.td-cell:nth-child(1) {
  text-align: center;
}
</style>
